module.exports = __webpack_public_path__ + "img/task-success.3db7954b.svg";